import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BugsnagService, ServiceException, SystemMaintenanceException, VersionDeprecatedException } from '@uzurv/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UZURV_REST_CONFIGURATION } from '../../interfaces/uzurv-rest-configuration';

@Injectable()
export class UzurvDataProcessorHttpInterceptor implements HttpInterceptor {
  constructor(
    @Inject(UZURV_REST_CONFIGURATION) protected uzurvRestConfiguration: UzurvRestConfiguration,
    private bugsnagService: BugsnagService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only process uzurv api requests
    if (
      !request.url.startsWith(this.uzurvRestConfiguration.claraApiUrl) &&
      !request.url.startsWith(this.uzurvRestConfiguration.dotsApiUrl)
    ) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          if (event.body && event.body['errors'] && event.body['errors'].length > 0) {
            // Handle System Events
            event.body['errors'].forEach((errorMessage: string) => {
              if (errorMessage.includes('Maintenance:')) {
                throw new SystemMaintenanceException(errorMessage.replace('Maintenance:', '').trim());
              }

              if (errorMessage.includes('Deprecation:')) {
                throw new VersionDeprecatedException(errorMessage.replace('Deprecation:', '').trim());
              }
            });
            throw new ServiceException(this.extractErrorMessages(event.body['errors']));
          } else if (event.body) {
            event = event.clone({ body: event.body['data'] });
          }
        }
        return event;
      })
    );
  }

  private extractErrorMessages(errors: Array<string>): string {
    return errors.join('<br />');
  }
}
